import { Component, EventEmitter, Input, Output, inject, effect } from '@angular/core';
import { ParcelService } from '../../shared/services/parcel.service';
import { MessageService } from 'primeng/api';
import { Parcel } from '../../shared/models/parcel';
import { DataService } from '../../shared/services/data.service';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';
import { FileViewerComponent } from "../../shared/components/file-viewer/file-viewer.component";
import { FormatDateTimePipe } from "../../pipes/format-date-time.pipe";
import { toSignal } from '@angular/core/rxjs-interop';


@Component({
  selector: 'app-parcel-detail',

  templateUrl: './parcel-detail.component.html',
  styleUrl: './parcel-detail.component.scss',
  standalone:true,
  imports: [...PRIMENG_MODULES, FileViewerComponent, FormatDateTimePipe]
})
export class ParcelDetailComponent {
  itemId: string = '';
  selectedFileName: string = '';
  selectedFileUrl: string = '';
  images!: any[];
  isNotFound: boolean = false;
  isLoading: boolean = false;
  loadingFinished: boolean = false;
  loadingReprocess: boolean = false;

  message = '';
  status: string = '';

  response: any;
  versions: any = [];

  @Input() parcel: Parcel[] = [];
  @Input() hideAssignActions: boolean = false;
  @Output() notFound = new EventEmitter<void>();
  @Output() apiSuccess = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
  parcelDetails: any;
  parcelImage: boolean = false;
  updater: string | undefined;
  users: any;
  currentPath: any;
  showFinishBtn: boolean = true;
  showUnassignBtn: boolean = false;
  userDropDownSelected: boolean = false;
  selectedOption: any = null;
  btnDisable: boolean = false;
  private readonly route = inject(ActivatedRoute);
  private readonly routeUrl = toSignal(this.route.url, { initialValue: [] as UrlSegment[] });
  constructor(private parcelService: ParcelService,
    private dataService: DataService,
    private messageService: MessageService
  ) {
    effect(() => {
      this.updater = this.dataService.currentDataSignal();
    });
  }

  ngOnChanges() {
    if (this.parcel) {
      
      this.loadParcelImage();
    }
  }

  ngOnInit() {
    const seg = this.routeUrl();
    this.currentPath = seg.map((segment: UrlSegment) => segment.path).join('/');

    if (this.hideAssignActions) {
      return;
    }

    this.parcelService.getUsers().subscribe(
      result => {
        this.users = result.users.filter((user: any) => (user != this.updater && user != 'Firma'))
        let options = ['Assign to Me', 'Reprocess', 'Firma'];
        if (this.currentPath === 'AssignedToMe') {
          this.showUnassignBtn = true;
          options = options.filter((op: string) => op != 'Assign to Me')
        }
        if (this.currentPath === 'Unassigned') {
          this.showFinishBtn = false;
          this.showUnassignBtn = false;
          options = options.filter((op: string) => op != 'Reprocess')
        }
        if (this.currentPath === 'Reprocessing') {
          this.showFinishBtn = true;
          this.showUnassignBtn = false;
          options = options.filter((op: string) => op != 'Reprocess')
        }
        if (this.currentPath === 'Firma') {
          this.showFinishBtn = true;
          this.showUnassignBtn = true;
          options = options.filter((op: string) => op != 'Firma')
        }
        if (this.currentPath === 'Allassigned') {
          this.showFinishBtn = true;
          this.showUnassignBtn = true;
          this.users = this.users.filter((user: any) => (user != this.parcelDetails.userId))
          if (this.parcelDetails.userId === this.updater) {
            options = options.filter((op: string) => op != 'Assign to Me')
          }
          if (this.parcelDetails.userId === 'Firma') {
            options = options.filter((op: string) => op != 'Firma')
          }
        }
        this.users = [...options, ...this.users];
      }
    );


  }



  loadParcelImage() {
    this.parcelDetails = this.parcel;
    this.itemId = this.parcelDetails.itemId;

    this.isLoading = true;

    this.parcelService.searchImage(this.parcelDetails.itemId, this.parcelDetails['image-names']).subscribe(
      result => {
        this.parcelImage = true;
        this.versions = [];
        this.images = [];
        this.isLoading = false;
        this.response = result
        for (let version of result.versions) {

          const imageNames = version.metadata['image-names'].split(':');
          const imageDateTimes = version.metadata['image-datetimes'].split(':');
          const imageUrls = version.urls;
          let date = imageDateTimes[0];

          for (let i = 0; i < imageNames.length; i++) {
            if (!this.isSupportedVersionUrl(imageUrls[i])) {
              continue;
            }

            this.images.push({
              imageName: imageNames[i],
              imageDateTime: imageDateTimes.length > 1 ? imageDateTimes[i] : date,
              imageUrl: imageUrls[i]
            });
          }

          this.versions.push({
            metadata: version.metadata,
          });
        }

        // select the first image after search
        this.selectedFileName = this.images[0].imageName;
        this.selectedFileUrl = this.images[0].imageUrl;
        this.dataService.updatePrintData({
          'selectedFileName': this.selectedFileName,
          'selectedFileUrl': this.selectedFileUrl,
          'itemId': this.itemId
        })
      },
      (error) => {
        this.notFound.emit();
        //  this.parcelImage = false;
        this.isLoading = false;
        this.isNotFound = true;

        this.resetUI();
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Something went wrong. Please try again later' });
      }
    );
  }

  onImageClick(event: MouseEvent, image: any): void {
    event.preventDefault();
    this.selectedFileName = image.imageName;
    this.selectedFileUrl = image.imageUrl;
    this.dataService.updatePrintData({
      'selectedFileName': this.selectedFileName,
      'selectedFileUrl': this.selectedFileUrl,
      'itemId': this.itemId
    })
  }

  resetUI() {
    this.parcelDetails = [];
    this.selectedFileName = '';
    this.selectedFileUrl = '';
    this.versions = [];
    this.images = [];
  }

  onSelectionChange() {
    this.userDropDownSelected = true;
    let user: any = this.selectedOption === 'Assign to Me' ? this.updater : 'admin';
    let status: any = 'assigned'
    if (this.selectedOption != 'Assign to Me' && this.selectedOption != 'Reprocess') {
      user = this.selectedOption;
    }
    if (this.selectedOption === 'Reprocess') {
      status = 'reprocessing';
    }
    let reAssignFromItemDetail = true;
    if (this.currentPath === 'Unassigned' || this.currentPath === 'Reprocessing') {
      reAssignFromItemDetail = false;
    }
    const queryParams = {
      itemId: this.parcelDetails.itemId,
      userId: user,
      status: status,
      updater: this.updater,
      reAssignFromItemDetail

    }

    this.onUpdateParcelItem(queryParams);

  }
  onUnAssign() {
    this.btnDisable = true;
    const queryParams = {
      itemId: this.parcelDetails.itemId,
      userId: 'admin',
      status: 'unassigned',
      updater: this.updater,

    }
    this.onUpdateParcelItem(queryParams);

  }

  onUpdateParcelItem(queryParams: any = {}) {
    this.parcelService.updateParcelAssigned(queryParams).subscribe({
      next: (response) => {
        this.btnDisable = false;
        this.userDropDownSelected = false;
        let msg = 'Item Assigned to ' + queryParams.userId;
        if (queryParams.userId === 'admin' && queryParams.status === 'reprocessing') {
          msg = 'Item Move to Reprocessing';
        }
        if (queryParams.userId === 'admin' && queryParams.status === 'unassigned') {
          msg = 'Item is Unassigned';
        }
        if (queryParams.status === 'handled') {
          msg = 'Item is Handled';
        } else {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: msg });
          this.loadingFinished = false;
          this.loadingReprocess = false;
        }
        this.apiSuccess.emit({oldStatus:this.parcelDetails.status,oldUserId:this.parcelDetails.userId,...queryParams});

      },
      error: (error) => {
        this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Failed to handle item. Try again later' });
        this.message = 'Failed to handle item. Try again later'
        this.loadingFinished = false;
        this.loadingReprocess = false;
      }
    })
  }
  onHandled() {
    this.btnDisable = true;
    const queryParams = {
      itemId: this.parcelDetails.itemId,
      userId: this.updater,
      status: 'handled',
      updater: this.updater,

    }
    this.onUpdateParcelItem(queryParams);
  }
  ngOnDestroy(): void {
    this.dataService.updatePrintData({})
  }
isSupportedVersionUrl(url: string | undefined): boolean {
    return !!url && !/\.(txt|xml)(\?|$)/i.test(url);
  }
}